const formatAmount = (number = 0) => {
  const f = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return f.format(number / 100)
}

export default formatAmount
